import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { of } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';
import { Pricing } from 'src/app/models/pricing.model';
import { PricingService } from 'src/app/services/pricing.service';
import { LookUpService } from 'src/app/services/lookup.service';
import Swal from 'sweetalert2';
import { SeoService } from 'src/app/services/seo.service';

@Component({
    selector: 'app-pricing-page',
    templateUrl: './pricing-page.component.html',
    styleUrls: ['./pricing-page.component.scss'],
    standalone: false
})
export class PricingPageComponent implements OnInit {
  isLoading: boolean;
  models: any[];
  phone: string | undefined;
  
  constructor(
    public service: PricingService,
    public translateService: TranslateService,
    public toastr: ToastrService,
    private router: Router,
    public lookupService: LookUpService,
    private seoService: SeoService
  ) {
    this.lookupService.getAll$().subscribe(x => {
      this.phone = x.find(x => x?.name == "Phone")?.value;
    });
  }
  ngOnInit(): void {
    // Set SEO for packages page
    this.seoService.updateSEO({
      title: 'Driving Lesson Packages | Staten Driving School',
      description: 'Choose from 5 driving lesson packages starting at $195. Includes road test prep, car for road test, and DMV appointment. Book your package today.',
      keywords: 'driving packages Staten Island, driving lesson packages, road test package, DMV test package',
      url: '/packages',
      canonical: 'https://statendrivingschool.com/packages'
    });

    this.service.getAll$().subscribe(x => {
      this.models = x;
      this.isLoading = true;
      
      // Add ItemList schema for packages
      if (x && x.length > 0) {
        const itemListSchema = {
          "@context": "https://schema.org",
          "@type": "ItemList",
          "itemListElement": x.map((pkg: any, index: number) => ({
            "@type": "ListItem",
            "position": index + 1,
            "item": this.seoService.getProductSchema(pkg)
          }))
        };
        this.seoService.addStructuredData(itemListSchema);
      }
    })
  }
  createImgPath = (serverPath: string) => {
    return this.service.createImgPath(serverPath);
  }

  isSaving: boolean;
  loading: boolean;
  savingItemId: string;

  selectPackage(referenceId: string) {
    const token = localStorage.getItem('token');
    if (!token) {
      Swal.fire({
        icon: 'warning',
        title: 'You must login first',
        showConfirmButton: false,
        timer: 2000
      }).then(() => {
        localStorage.setItem('redirectAfterLogin', `/packages/select/${referenceId}`);
        this.router.navigate(['/authentication/login']);
      });

      return;
    }

    this.savingItemId = referenceId;

    this.service.selectPackage$(referenceId).pipe(
      finalize(() => {
        this.savingItemId = null;
      })
    ).subscribe(content => {
      if (content) {
        this.toastr.success("Added Success");
        this.router.navigate(['/payment/pending-pakages']);
      }
    }, () => {
      this.savingItemId = null;
    });
  }
  // sanitizeDetails(details: string): string {
  //   const div = document.createElement('div');
  //   div.innerHTML = details;

  //   const listItems = div.querySelectorAll('li');
  //   listItems.forEach(li => {
  //     li.innerHTML = `<i class='bx bxs-check-circle'></i> ${li.innerHTML}`;
  //   });

  //   return div.innerHTML;
  // }


}
